import { Badge } from "@/components/ui/badge.js";

type Tone = "neutral" | "accent" | "warn" | "risk" | "success" | "copper" | "ai" | "system";

const TONE: Record<string, Tone> = {
  // ListingStatus
  bozza: "neutral",
  disponibile: "accent",
  prezzo_su_richiesta: "ai",
  in_trattativa: "warn",
  riservato: "copper",
  venduto: "neutral",
  archiviato: "neutral",
  // InquiryStatus
  nuovo: "accent",
  visto: "neutral",
  in_carico: "warn",
  chiuso: "success",
  // BookingStatus
  richiesta: "accent",
  confermata: "warn",
  completata: "success",
  annullata: "neutral",
  // FieldStatus
  documentato: "accent",
  confermato_agente: "success",
  da_appunto: "system",
  dedotto_foto: "ai",
  probabile: "warn",
  mancante: "risk",
};

const LABEL: Record<string, string> = {
  bozza: "bozza",
  disponibile: "disponibile",
  prezzo_su_richiesta: "su richiesta",
  in_trattativa: "in trattativa",
  riservato: "riservato",
  venduto: "venduto",
  archiviato: "archiviato",
  nuovo: "nuovo",
  visto: "visto",
  in_carico: "in carico",
  chiuso: "chiuso",
  richiesta: "richiesta",
  confermata: "confermata",
  completata: "completata",
  annullata: "annullata",
  documentato: "documentato",
  confermato_agente: "confermato",
  da_appunto: "da appunto",
  dedotto_foto: "dedotto",
  probabile: "probabile",
  mancante: "mancante",
};

export function statusLabel(status: string): string {
  return LABEL[status] ?? status;
}

export function StatusPill({ status }: { status: string }): JSX.Element {
  return <Badge tone={TONE[status] ?? "neutral"}>{statusLabel(status)}</Badge>;
}
